export const useLoyaltyProgramActivated = () => ({
  isLoyaltyProgramV1Enabled: false,
  isLoyaltyProgramV2Enabled: false,
  isOptInLoyaltyProgramV2: false,
  isOptOutLoyaltyProgramV2: false,
});
